import styled from '@emotion/styled';

export const ContainerHistori = styled.div`
  margin: 48px;
`;
